export default function Header() {
  const header: HTMLElement | null = document.querySelector("header");
  const broadcastBlock: HTMLElement | null = document.querySelector(".broadcast-block")

  if (header) {
    const searchMenuWrapper: HTMLDivElement | null = header.querySelector(".js-mobile-search-menu-wrapper");
    const searchMenuBtn: HTMLButtonElement | null = header.querySelector(".js-mobile-menu-btn");
    const searchMenuBtnClosedIcon: HTMLSpanElement | null | undefined = searchMenuBtn?.querySelector(".js-mobile-closed-icon");
    const searchMenuBtnOpenIcon: HTMLSpanElement | null | undefined = searchMenuBtn?.querySelector(".js-mobile-open-icon");
    const menuItems = header.querySelectorAll<HTMLLIElement>(".js-mobile-item");
    const activeMenuItems = searchMenuWrapper?.querySelectorAll<HTMLDivElement>("[data-active]");
    
    const handleMenuHeight = () => {
      return window.innerHeight - header.offsetHeight;
    };
    
    const handleOpenSearchMenu = () => {
      if (searchMenuBtn && searchMenuBtnClosedIcon && searchMenuBtnOpenIcon && searchMenuWrapper) {
        // update search btn and icons
        searchMenuBtn.classList.add("is-open");
        searchMenuBtnClosedIcon.style.display = "none";
        searchMenuBtnOpenIcon.style.display = "flex";
        searchMenuWrapper.style.transform = "translateX(0)";
        searchMenuWrapper.style.height = `${handleMenuHeight()}px`;
        document.body.style.overflow = "hidden";
        
        if(broadcastBlock) {
          const headerIsSticky = header.getAttribute("data-issticky")
          if(headerIsSticky === "false") {
            searchMenuWrapper.style.paddingBottom = `${broadcastBlock.offsetHeight}px`;
          } else {
            searchMenuWrapper.style.paddingBottom = "30px";
          }
        }
      }
    };

    const handleCloseSearchMenu = () => {
      if (searchMenuBtn && searchMenuBtnClosedIcon && searchMenuBtnOpenIcon && searchMenuWrapper) {
        // update search btn and icons
        searchMenuBtn.classList.remove("is-open");
        searchMenuBtnClosedIcon.style.display = "flex";
        searchMenuBtnOpenIcon.style.display = "none";
        searchMenuWrapper.style.transform = "translateX(100%)";
        searchMenuWrapper.style.height = "";
        document.body.style.overflow = "";
        
        if(broadcastBlock) {
          searchMenuWrapper.style.paddingBottom = "0"
        }
      }


      if (activeMenuItems && activeMenuItems.length > 0) {
        activeMenuItems.forEach((menu) => {
          menu.setAttribute("data-active", "false");
          (menu as HTMLElement).style.height = "";
        });
      }
    };

    const toggleSearchMenu = () => {
      if (searchMenuBtn && searchMenuBtn.classList.contains("is-open")) {
        handleCloseSearchMenu();
      } else {
        handleOpenSearchMenu();
      }
    };

    const handleResize = () => {
      if (searchMenuBtn && searchMenuBtn.classList.contains("is-open")) {
        if (searchMenuWrapper) {
          searchMenuWrapper.style.height = `${handleMenuHeight()}px`;
          
          // Update active submenu heights as well
          const activeSubmenus = searchMenuWrapper.querySelectorAll<HTMLDivElement>('.js-mobile-menu[data-active="true"]');
          activeSubmenus.forEach((submenu) => {
            submenu.style.height = `${handleMenuHeight()}px`;
          });
        }
      }
    };

    if (searchMenuBtn) {
      searchMenuBtn.addEventListener("click", toggleSearchMenu);
    }

    if (menuItems && menuItems.length > 0) {
      menuItems.forEach((item) => {
        const nextBtn = item.querySelector(".js-next-btn");
        const backBtn = item.querySelector(".js-back-btn");
        const mobileMenu = item.querySelector<HTMLDivElement>(".js-mobile-menu");

        const handleNextMenu = () => {
          if (mobileMenu) {
            mobileMenu.setAttribute("data-active", "true");
            mobileMenu.style.height = `100vh`;
          }
        };

        const handlePreviousMenu = () => {
          if (mobileMenu) {
            mobileMenu.setAttribute("data-active", "false");
            mobileMenu.style.height = "";
          }
        };

        if (nextBtn) {
          nextBtn.addEventListener("click", handleNextMenu);
        }

        if (backBtn) {
          backBtn.addEventListener("click", handlePreviousMenu);
        }
      });
    }

    window.addEventListener("resize", handleResize);
  }
}
